// extracted by mini-css-extract-plugin
export default {"package":"d191419d769f"};